import { createRoute } from '@tanstack/react-router';
import { lazy } from 'react';
import { authenticatedRoute } from '../_authenticated';

const SchemaFormPage = lazy(() =>
  import('@/features/schemas/components/SchemaFormPage').then((m) => ({
    default: () => m.SchemaFormPage({ mode: 'create' }),
  })),
);

export const schemaNewRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/schemas/new',
  component: SchemaFormPage,
});
